import Vue from 'vue';
import Vuex from 'vuex';
import session from '@demre/client-common/src/components/jwt-refresher/session';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fases: [],
    sedes: [],
    nominaExaminador: [],
    funciones: [],
    bancos: [],
    modulos: [],
    paises: [],
    roles: {},
    usuario: {},
    proceso: {},
    estadoConfirmar: null,
  },
  modules: {
    session,
  },
  getters,
  actions,
  mutations,
});
